import { useStandardLoanStore } from '../../../../../state/standardLoanStore';
import { BorrowerSelector } from '../../../../../../../../common/components/v2/BorrowerSelector/BorrowerSelector';
import { BorrowerType } from '../../../../../../../../common/components/v2/BorrowerSelector/constants/borrowerSelection';
import { BrokerSelector } from '../../../../../../../../common/components/v2/BrokerSelector/BrokerSelector';
import { BorrowerLinkedNotice } from './components/BorrowerLinkedNotice';
import { isBorrowerLocked } from './functions/isBorrowerLocked';
import { ItemRow } from '../../ItemRow/ItemRow';
import {
    Expander,
    ExpanderBorderRoundingStyle,
    ExpanderBorderStyle,
    ExpanderButtonStyle,
    ExpanderHeaderSpacing,
    ExpanderTheme,
} from '@apply/components';
import '../styles/_sectionContent.scss';

/**
 * The Borrower fields of the "Setup & Borrower" step: a new version of the Borrower section of EditStdLoanModal. The
 * BorrowerSelector's selection is kept in the standard loan store, and a "Borrower Only" loan can also name a broker.
 */
export const Borrower = () => {
    const borrowerType = useStandardLoanStore((state) => state.borrower.borrowerType);
    const borrowerEntityId = useStandardLoanStore((state) => state.borrower.borrowerEntityId);
    const brokerAgreementId = useStandardLoanStore((state) => state.borrower.brokerAgreementId);
    const isLocked = useStandardLoanStore((state) =>
        isBorrowerLocked(state.setupLoanContext.isSubNote, state.borrowerLoanContext)
    );
    const brokerId = useStandardLoanStore((state) => state.borrower.brokerId);
    // Sub notes take their broker from the master note; a loan created for a B-Client can still change it
    const isSubNote = useStandardLoanStore((state) => state.setupLoanContext.isSubNote);
    const setBorrowerSelection = useStandardLoanStore((state) => state.setBorrowerSelection);
    const selectBroker = useStandardLoanStore((state) => state.selectBroker);

    return (
        <Expander
            header={<h2>Borrower</h2>}
            initialExpanded={true}
            theme={ExpanderTheme.White}
            buttonStyle={ExpanderButtonStyle.NoRounding}
            borderRoundingStyle={ExpanderBorderRoundingStyle.NoRounding}
            borderStyle={ExpanderBorderStyle.None}
            headerSpacing={ExpanderHeaderSpacing.None}
            width='auto'
            height='30px'
        >
            <div className='setupAndBorrowerSectionContent'>
                <BorrowerLinkedNotice />
                <ItemRow>
                    <BorrowerSelector
                        borrowerEntityId={borrowerEntityId}
                        brokerAgreementId={brokerAgreementId}
                        onChange={setBorrowerSelection}
                        disabled={isLocked}
                    />
                </ItemRow>
                {borrowerType === BorrowerType.Entity && (
                    <ItemRow>
                        <BrokerSelector
                            brokerId={brokerId}
                            onChange={selectBroker}
                            disabled={isSubNote}
                        />
                    </ItemRow>
                )}
            </div>
        </Expander>
    );
};
